import {
  Box,
  Button,
  Checkbox,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import dayjs from "dayjs";
import {
  ArrowDownward,
  ArrowUpward,
  SwapVert as SwapVertIcon,
  Edit as EditIcon,
  EmailOutlined as EmailIcon,
} from "@mui/icons-material";

export const columns = ({
  setSortBy,
  sortBy,
  isDescending,
  handleEditUser,
  handleSelectAll,
  selectedIds,
  handleSelect,
  handleResetPassword, // New handler for reset password
}) => [
  {
    accessorKey: "fullName",
    header: ({ table }) => (
      <div style={{ display: "flex", alignItems: "center" }}>
        <Checkbox
          indeterminate={table.getIsSomeRowsSelected()}
          checked={table.getIsSomeRowsSelected().length === 10}
          onChange={() => handleSelectAll()}
          style={{ color: "white" }}
        />
        <Typography variant="body2">User name</Typography>
        <div
          onClick={() => {
            // If clicking the same column, toggle direction
            // If clicking a different column, set to descending (true)
            const newIsDescending =
              sortBy === "fullName" ? !isDescending : true;
            setSortBy("fullName", newIsDescending);
          }}
          style={{ cursor: "pointer" }}
        >
          {sortBy === "fullName" ? (
            isDescending == false ? (
              <ArrowUpward style={{ fontSize: "1rem", cursor: "pointer" }} />
            ) : (
              <ArrowDownward style={{ fontSize: "1rem", cursor: "pointer" }} />
            )
          ) : (
            <SwapVertIcon style={{ fontSize: "1rem", cursor: "pointer" }} />
          )}{" "}
        </div>
      </div>
    ),
    cell: ({ row, value }) => (
      <>
        <Checkbox
          checked={selectedIds.includes(row.original.id)}
          onChange={() => handleSelect(row.original.id)}
        />
        <Box component="span" sx={{ marginLeft: 1 }}>
          {row.original.fullName}
        </Box>
      </>
    ),
  },
  {
    accessorKey: "email",
    header: () => (
      <div
        style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        onClick={() => {
          const newIsDescending = sortBy === "email" ? !isDescending : true;
          setSortBy("email", newIsDescending);
        }}
      >
        <Typography variant="body2">Email</Typography>
        {sortBy === "email" ? (
          isDescending == false ? (
            <ArrowUpward style={{ fontSize: "1rem", cursor: "pointer" }} />
          ) : (
            <ArrowDownward style={{ fontSize: "1rem", cursor: "pointer" }} />
          )
        ) : (
          <SwapVertIcon style={{ fontSize: "1rem", cursor: "pointer" }} />
        )}{" "}
      </div>
    ),
  },
  {
    accessorKey: "locationId",
    header: () => (
      <div
        style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        onClick={() => {
          const newIsDescending = sortBy === "location" ? !isDescending : true;
          setSortBy("location", newIsDescending);
        }}
      >
        <Typography variant="body2">Location</Typography>
        {sortBy === "location" ? (
          isDescending == false ? (
            <ArrowUpward style={{ fontSize: "1rem", cursor: "pointer" }} />
          ) : (
            <ArrowDownward style={{ fontSize: "1rem", cursor: "pointer" }} />
          )
        ) : (
          <SwapVertIcon style={{ fontSize: "1rem", cursor: "pointer" }} />
        )}{" "}
      </div>
    ),
  },
  {
    accessorKey: "dateCreated",
    header: () => (
      <div
        style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        onClick={() => {
          const newIsDescending =
            sortBy === "dateCreated" ? !isDescending : true;
          setSortBy("dateCreated", newIsDescending);
        }}
      >
        <Typography variant="body2">Date Created</Typography>
        {sortBy === "dateCreated" ? (
          isDescending == false ? (
            <ArrowUpward style={{ fontSize: "1rem", cursor: "pointer" }} />
          ) : (
            <ArrowDownward style={{ fontSize: "1rem", cursor: "pointer" }} />
          )
        ) : (
          <SwapVertIcon style={{ fontSize: "1rem", cursor: "pointer" }} />
        )}{" "}
      </div>
    ),
    cell: ({ row }) => (
      <>
        <Box component="span" sx={{ marginLeft: 1 }}>
          {dayjs(row.original.dateCreated).format("DD/MM/YYYY")}
        </Box>
      </>
    ),
  },
  {
    accessorKey: "userType",
    header: () => (
      <div
        style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        onClick={() => {
          const newIsDescending = sortBy === "userType" ? !isDescending : true;
          setSortBy("userType", newIsDescending);
        }}
      >
        <Typography variant="body2">Type</Typography>
        {sortBy === "userType" ? (
          isDescending == false ? (
            <ArrowUpward style={{ fontSize: "1rem", cursor: "pointer" }} />
          ) : (
            <ArrowDownward style={{ fontSize: "1rem", cursor: "pointer" }} />
          )
        ) : (
          <SwapVertIcon style={{ fontSize: "1rem", cursor: "pointer" }} />
        )}{" "}
      </div>
    ),
  },
  {
    accessorKey: "userGroup",
    header: () => (
      <div
        style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        onClick={() => {
          const newIsDescending = sortBy === "userGroup" ? !isDescending : true;
          setSortBy("userGroup", newIsDescending);
        }}
      >
        <Typography variant="body2">Group</Typography>
        {sortBy === "userGroup" ? (
          isDescending == false ? (
            <ArrowUpward style={{ fontSize: "1rem", cursor: "pointer" }} />
          ) : (
            <ArrowDownward style={{ fontSize: "1rem", cursor: "pointer" }} />
          )
        ) : (
          <SwapVertIcon style={{ fontSize: "1rem", cursor: "pointer" }} />
        )}{" "}
      </div>
    ),
  },
  {
    id: "actions",
    header: () => <Typography variant="body2">Actions</Typography>,
    cell: ({ row }) => (
      <Box sx={{ display: "flex", gap: 1 }}>
        <Tooltip title="Edit User" arrow>
          <IconButton
            size="small"
            onClick={() => handleEditUser(row.original.id)}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Resend welcome E-mail" arrow>
          <IconButton
            size="small"
            onClick={() =>
              handleResetPassword(row.original.id, row.original.email)
            }
          >
            <EmailIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    ),
  },
];
